import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaConfiguracionFacturacionComponent {
  empresaId = undefined
  guardar = false
  form
  proveedor = {}

  constructor ($q, EmpresaCatalogoProveedorFacturacion, EmpresaConfiguracionFacturacion) {
    this.$q = $q
    this.EmpresaCatalogoProveedorFacturacion = EmpresaCatalogoProveedorFacturacion
    this.EmpresaConfiguracionFacturacionService = EmpresaConfiguracionFacturacion
  }

  $onInit () {
    this.promise = this.$q.all([
      this.EmpresaCatalogoProveedorFacturacion.get()
        .then((response) => (this.proveedor = response.data)),
      this.EmpresaConfiguracionFacturacionService.get(this.empresaId)
        .then((response) => (this.data = response.data)),
    ])
  }

  cerrar (data) {
    this.guardar = false
    data.exito ? this.form.$setPristine() : angular.noop()
  }
}

module.component('empresaConfiguracionFacturacion', {
  controller: EmpresaConfiguracionFacturacionComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/facturacion/component.js